module.exports = __webpack_public_path__ + "img/research-2.3419a7e1.jpg";